const buildConfig = require('../build/' + process.env.BUILD_ENV + '.js');

const Http = function() {};

Http.prototype.fetch = function(url, method, params = {}, fetchConfig = {}) {
    url = buildConfig.BASE_URL + url;
    if (this.beforeRequest) {
        this.beforeRequest();
    }
    let config = { method: method, mode: 'cors' };
    if (method == 'get' || method == 'head') {
        if (url.indexOf('?') > 0) {
            url += '&';
        } else {
            url += '?';
        }
        for (let key in params) {
            let value = params[key];
            if (typeof(value) == 'function' || value === undefined || value === '') {
                continue;
            }
            url += key + '=' + value + '&';
        }
    } else {
        let obj = {};
        for (let key in params) {
            let value = params[key];
            if (typeof(value) == 'function' || value === undefined) {
                continue;
            }
            obj[key] = value;
        }
        config.body = JSON.stringify(obj);
    }
    config.headers = {
        'Content-Type': params instanceof FormData ? 'multipart/form-data' : 'application/json',
    };
    if (localStorage.adminToken) {
        config.headers.Authorization = 'Bearer ' + localStorage.adminToken;
    }
    return new Promise((resolve, reject) => {
        fetch(url, config).then(async res => {
            if (this.afterRequest) {
                this.afterRequest();
            }
            if (res.status == 200) {
                let data = await res.json();
                if (data.code == 200) {
                    resolve(data.data || data);
                } else {
                    if (this.onApiError) {
                        this.onApiError(data);
                    }
                    if (fetchConfig.onError) {
                        fetchConfig.onError(data.msg);
                    } else {
                        reject(data.msg);
                    }
                }
            } else {
                if (this.onApiError) {
                    this.onApiError({ code: res.status, msg: res.status.toString() });
                }
            }
            if (fetchConfig.onComplete) {
                fetchConfig.onComplete();
            }
        });
    });
};

Http.prototype.get = function(url, params, config) {
    return this.fetch(url, 'get', params, config);
};

Http.prototype.post = function(url, params, config) {
    return this.fetch(url, 'post', params, config);
};

Http.prototype.put = function(url, params, config) {
    return this.fetch(url, 'put', params, config);
};

Http.prototype.delete = function(url, params, config) {
    return this.fetch(url, 'delete', params, config);
};

export default new Http();
